import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveCustomer, removeCustomer, getCustomerFull, captureLeadPortfolio } from '../modules/customerdata';
import { getDuplicates } from '../modules/duplicatedata';
import { getTenants } from '../modules/tenantdata';
import CustomerEditView from './customereditview';
import Spinner from '../common/spinner';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function CustomerEditViewContainer(props) {
    const id = props.match.params.customerId !== 'new' ? parseInt(props.match.params.customerId, 10) : 'new';
    const dispatch = useDispatch();

    const customersById = useSelector((state) => state.customerdata.customersById);
    const getCustomerByIdInProgress = useSelector((state) => state.customerdata.getCustomerByIdInProgress);
    const getCustomerByIdFailed = useSelector((state) => state.customerdata.getCustomerByIdFailed);
    const savingCustomer = useSelector((state) => state.customerdata.isSavingData);
    const saveCustomerDone = useSelector((state) => state.customerdata.saveDataDone);
    const saveCustomerFail = useSelector((state) => state.customerdata.saveDataFailed);
    const userProfile = useSelector((state) => state.authentication.userProfile);
    const removeCustomerStatus = useSelector((state) => state.customerdata.removeCustomerStatus);
    const parameters = useSelector((state) => state.parameterdata.parameters);
    const contracts = useSelector((state) => state.contractdata.contractsById);
    const duplicates = useSelector((state) => state.duplicatedata.duplicates);
    const tenants = useSelector((state) => state.tenantdata.tenants);
    const activeTenantId = useSelector((state) => state.tenantdata.activeTenantId);
    const isFetchingTenants = useSelector((state) => state.tenantdata.isFetching);
    const { t } = useTranslation();

    useEffect(() => {
        if (!isFetchingTenants && (!tenants || tenants.length === 0)) {
            dispatch(getTenants());
        }
    }, [tenants, isFetchingTenants, dispatch]);

    const doCustomerSave = (customer) => {
        return dispatch(saveCustomer(customer));
    };

    const doCustomerRemove = (customer) => {
        return dispatch(removeCustomer(customer));
    };

    const doCaptureLeadPortfolio = (customerId, portfolioId) => {
        return dispatch(captureLeadPortfolio(customerId, portfolioId));
    };

    const asLead = !!(props.location && props.location.state && props.location.state.asLead);

    const checkDuplicates = (id, customerId, name, businessId) => {
        dispatch(getDuplicates(id, customerId, name, businessId));
    };

    if (id !== 'new' && customersById[id] == null && !getCustomerByIdInProgress && !getCustomerByIdFailed) {
        dispatch(getCustomerFull(id));
    }

    if (props.getCustomerByIdInProgress) {
        return <Spinner padding="20px" title={t('general.loading')} />;
    } else if (!props.getCustomerByIdInProgress && props.getCustomerByIdFailed) {
        return (
            <div style={{ padding: '20px' }}>
                <Alert severity="error">{t('customer.failedToRetrieveCustomerDataRetry')}</Alert>
            </div>
        );
    }

    return (
        <CustomerEditView
            history={props.history}
            userProfile={userProfile}
            customer={customersById[id]}
            savingCustomer={savingCustomer}
            saveCustomerDone={saveCustomerDone}
            saveCustomerFail={saveCustomerFail}
            saveCustomer={doCustomerSave}
            removeCustomer={doCustomerRemove}
            captureLeadPortfolio={doCaptureLeadPortfolio}
            newCustomer={id === 'new'}
            asLead={asLead}
            customerRemoveStatus={removeCustomerStatus[id]}
            parameters={parameters}
            contracts={contracts}
            tenants={tenants}
            activeTenantId={activeTenantId}
            checkDuplicates={checkDuplicates}
            duplicates={duplicates}
        />
    );
}
